import React, { useEffect, useState } from "react";
import { deleteFile, submitCifOffer, uploadFile } from "@/api/placeOffer";
import { acknowledgementStatement } from "@/setting";
import { ShimmerText } from "react-shimmer-effects";
import { BsCheckCircleFill } from "react-icons/bs";
import { batch, useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { setLoginCallLocation, setLoginModal, setLoginTab } from "@/redux/login/loginSlice";
import { isValidSession } from "@/api/auth";

const EditProofOfFund = ({
  state,
  setAccordionState,
  accordionState,
  editCifData,
  setEditCifData,
  cifId,
  pof,
  documents,
  setSuccessMsg,
}) => {
  const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10MB
  const ACCEPTED_FILE_TYPES = ".pdf,.jpg,.jpeg";
  const FILE_CATEGORIES = {
    category: "USER_FUND_PROOF",
    subCategory: "POF",
  };
      const ACCEPTED_FILE_TYPES1 =  [
  "application/pdf",
  "image/jpeg",
  "image/jpg"
];
  const [pofConfig, setPofConfig] = useState({
    acknowledgement: false,
    proofOfFunds: [],
  });
  const dispatch  = useDispatch();
  const [uploadState, setUploadState] = useState({
    fileError: "",
    isUploading: false,
  });
  const [acknowledgementError, setAcknowledgementError] = useState("");
  const [loading, setLoading] = useState(false);

  const validateFile = (file) => {
    if (!file) return "Please select a file";
    if (file.size > MAX_FILE_SIZE) return "File size exceeds 10MB limit";
    if (!ACCEPTED_FILE_TYPES1.includes(file.type)) {
    return "Please upload document in pdf, jpg or jpeg format.";
    }
    return "";
  };

  const createFormData = (file) => {
    const formData = new FormData();
    const fileMetadata = {
      listingId: state?.listingId,
      fileCategory: FILE_CATEGORIES.category,
      cifId: cifId,
    };

    formData.append("file", file);
    formData.append(
      "fileUploadRequest",
      new Blob([JSON.stringify(fileMetadata)], { type: "application/json" })
    );

    return formData;
  };

  const updateFormDetails = (response) => {
    setPofConfig((prevState) => ({
      ...prevState,
      proofOfFunds: [...(prevState.proofOfFunds || []), response.data.data],
    }));
  };

  const handleFileUpload = async (event) => {
    setUploadState({ fileError: "", isUploading: true });
    const file = event.target.files[0];
    const error = validateFile(file);

    if (error) {
      setUploadState({ fileError: error, isUploading: false });
      event.target.value = "";
      return;
    }
    setUploadState({ fileError: "", isUploading: true });
    try {
      const formData = createFormData(file);

      const response = await uploadFile(formData);
       if(response?.data?.errorCode==="SESSION_EXPIRED"){
                toast.error("current session not valid, Please login again");
                    batch(() => {          
                      dispatch(setLoginModal(true));
                      dispatch(setLoginTab("loginTab"));
                      dispatch(setLoginCallLocation("Popup"));
                    });
            }else{
              updateFormDetails(response);
            }

      setUploadState({
        fileError: "",
        isUploading: false,
      });
    } catch (error) {
      setUploadState({
        fileError: error.message || "Error uploading file",
        isUploading: false,
      });
      event.target.value = "";
    } finally {
      setUploadState({
        fileError: "",
        isUploading: false,
      });
    }
  };

  const handleFileDelete = async (fileId) => {
    try {
      setUploadState({
        fileError: "",
        isUploading: true,
      });
      const listingId = state?.listingId;
      const data = await deleteFile({ fileId, listingId });
      if (data?.data?.status === "SUCCESS") {
        setPofConfig((prevState) => ({
          ...prevState,
          proofOfFunds: prevState?.proofOfFunds?.filter(
            (file) => file.documentId !== fileId
          ),
        }));
        setUploadState({
          fileError: "",
          isUploading: false,
        });
      } else {
        setUploadState({
          fileError: "Error deleting file",
          isUploading: false,
        });
      }
    } catch (error) {
      console.error("Error deleting file:", error);
      setUploadState({
        fileError: error.message || "Error deleting file",
        isUploading: false,
      });
    }
  };
  const handleFileDownload = async (documentId, fileName) => {
    try {
      const response = await fetch(
        `/portal/postcontract/download/${documentId}`,
        {
          method: "GET",
          credentials: "include",
        }
      );

      if (!response.ok) {
        throw new Error("File not found or access denied");
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = fileName || "download";
      document.body.appendChild(link);
      link.click();
      link.remove();

      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download failed:", error);
    }
  };
  const handleCheckboxChange = (event) => {
    setPofConfig((prevState) => ({
      ...prevState,
      acknowledgement: event.target.checked,
    }));
    setAcknowledgementError("");
  };
  // useEffect(()=>{
  //   if(documents?.pofFiles?.length>0){
  //    setPofConfig((prevState) => ({
  //     ...prevState,
  //     proofOfFunds: [...(prevState.proofOfFunds || []), ...documents?.pofFiles],
  //   }));
  //   }
  // },[documents])
  useEffect(() => {
    if (documents?.pofFiles?.length > 0) {
      setPofConfig((prevState) => {
        const existingDocs = prevState.proofOfFunds || [];

        // Create a map for quick lookup
        const existingDocMap = new Set(
          existingDocs.map((doc) => `${doc.name}_${doc.size}`)
        );

        // Filter only new docs that are not already in the list
        const newDocs = documents.pofFiles.filter(
          (doc) => !existingDocMap.has(`${doc.name}_${doc.size}`)
        );

        // If no new docs, return current state
        if (newDocs.length === 0) return prevState;

        return {
          ...prevState,
          proofOfFunds: [...existingDocs, ...newDocs],
        };
      });
    }
  }, [documents]);

  const submitDetails = async () => {
    try {
      const isFileRequired = pof === "Required";
      const hasRequiredFile = isFileRequired ? !!pofConfig.proofOfFunds : true;
      if (!pofConfig.acknowledgement || !hasRequiredFile) {
        setAcknowledgementError("Please accept the declaration");
        return;
      }
      if (
        hasRequiredFile &&
        pofConfig?.proofOfFunds?.length === 0 &&
        pof === "Required"
      ) {
        setUploadState({
          fileError:
            "Please upload at least one proof of funds document to proceed.",
          isUploading: false,
        });
        return;
      }
      if (!pofConfig.acknowledgement) {
        setAcknowledgementError("Please accept the declaration");
        return;
      }
      setLoading(true);

      const defaultCoBuyer = {
        firstName: "",
        lastName: "",
        email: "",
        middleInitials: "",
        phone: "",
        company: "",
        address1: "",
        address2: "",
        city: "",
        stateId: "",
        zip: "",
      };

      const payload = {
        buyer: editCifData.buyer,
        coBuyer:
          editCifData?.coBuyer &&
          Object?.getOwnPropertyNames(editCifData?.coBuyer).length === 0
            ? defaultCoBuyer
            : editCifData.coBuyer,
        buyerAgent: editCifData?.buyerAgent && Object.getOwnPropertyNames(editCifData?.buyerAgent).length===0?defaultCoBuyer:editCifData?.buyerAgent,

        closingAgent: editCifData?.closingAgent,
        titleProvider: editCifData?.titleProvider,
        closingInfoChoice: editCifData?.closingInfoChoice,
      };
                const isSessionValid = await isValidSession();
                    const isValid = isSessionValid.data?.isValidSession;
                if (isValid === "Y"){
      const data = await submitCifOffer({ cifId: cifId, payload: payload });
      if (data.data.status === "SUCCESS") {
        setSuccessMsg(true);
        // setCifCompleted(true);
        // setIsFromCif(true);
        setLoading(false);
      }else{
  setLoading(false);
      }
    }     else{ toast.error("current session not valid, Please login again");
              batch(() => {          
                dispatch(setLoginModal(true));
                dispatch(setLoginTab("loginTab"));
                dispatch(setLoginCallLocation("Popup"));
              });
              setLoading(false);
            }
    } catch (error) {
      console.log(error);
      setLoading(false);
      setSuccessMsg(false);
    }
  };

  const renderHeader = () => (
    <h2 className="accordion-header p-1" id="flush-headingFour">
      <div
        className={`accordion-button ${
          accordionState?.accordion4?.close ? "collapsed" : ""
        }`}
        // type="button"
        // data-bs-toggle="collapse"
        // data-bs-target="#flush-collapseFour"
        // aria-expanded="false"
        id="acc4"
        // aria-controls="flush-collapseFour"
        disabled={accordionState?.accordion4?.close}
      >
        <div className="d-flex justify-content-between w-100">
          <p className="mb-0">
            {accordionState?.accordion4?.visited ? (
              <BsCheckCircleFill className="icon_bid me-2" size={30} />
            ) : (
              <BsCheckCircleFill className="text-dark me-2" size={30} />
            )}
            Proof of Funds / Pre-Approval Letter
          </p>
        </div>
      </div>
    </h2>
  );

  const renderFileUpload = () => (
    <>
      <input
        type="file"
        name="proofOfFunds"
        onChange={handleFileUpload}
        accept={ACCEPTED_FILE_TYPES}
        id="proofOfFunds"
        // className="form-control w-75 pr-4"
        className="d-none"
        required={pof === "Required"}
        disabled={uploadState.isUploading}
      />
      <label htmlFor="proofOfFunds" className="llc-upload-btn">
        Upload Proof Of funds
      </label>
      <p className="info-uploaf">
        File formats accepted: pdf, jpg and jpeg. Maximum file size allowed is
        10MB.
      </p>

      {uploadState.fileError && (
        <div className={`error-message-offer`}>{uploadState.fileError}</div>
      )}
    </>
  );

  const renderAcknowledgement = () => (
    <>
      <div className="acknowledgement-section">
        <input
          type="checkbox"
          name="acknowledgement"
          id="acknowledgement"
          className="form-check-input"
          onChange={handleCheckboxChange}
          checked={pofConfig?.acknowledgement || false}
        />
        <label
          htmlFor="acknowledgement"
          className="form-check-label mx-1 acknowldegement-pof-offer"
        >
          {acknowledgementStatement}
        </label>
      </div>
      {acknowledgementError?.length > 0 && (
        <p className="error-message-offer">{acknowledgementError}</p>
      )}
    </>
  );

  return (
    <div className="accordion-item mb-2 border rounded">
      {renderHeader()}
      <div
        id="flush-collapseFour"
        className={`accordion-collapse collapse ${
          accordionState?.accordion4?.close ? "" : "show"
        }`}
        aria-labelledby="flush-headingFour"
        data-bs-parent="#accordionFlushExample"
      >
        <div className="accordion-body">
          <p className="instructions">
            To provide the seller with the necessary information to evaluate
            your bid, please upload the following supporting documentation. For
            cash purchases, please attach a bank statement, investment account
            statement, or similar document to verify adequate funds to close.
            For financed purchases, please attach a copy of a pre-approval
            letter from your selected financial institution. Please note that
            the buyer's name and the name on the proof of funds, or pre-approval
            letter, need to match in order for the seller to consider it.
          </p>
          <div className="buyer-form">
            {renderFileUpload()}
            {uploadState?.isUploading && (
              <ShimmerText line={2} gap={10} className="mt-2" />
            )}
            {pofConfig?.proofOfFunds?.length > 0 &&
              pofConfig?.proofOfFunds?.map((data) => (
                <>
                  <div className="p-2">
                    <div className="file-info d-flex align-items-center">
                      <img
                        src="/assets/images/downloadIconOffer.png"
                        height={"14px"}
                        width={"14px"}
                        className=""
                        onClick={() =>
                          handleFileDownload(data.documentId, data.fileName)
                        }
                      />
                      <span className="fs-12 filename-offer">
                        {data?.fileName}
                      </span>
                      <button
                        className="btn-delete-offer-file"
                        onClick={() => handleFileDelete(data?.documentId)}
                      >
                        Delete
                      </button>
                    </div>
                  </div>
                </>
              ))}
          </div>
          {renderAcknowledgement()}
          <button
            type="submit"
            className="continue-button"
            onClick={submitDetails}
            disabled={loading}
          >
            {loading ? "Submitting..." : "Submit"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditProofOfFund;
